import { useState } from "react";
import { Table, message } from "antd";
import moment from "moment";
import CustomDateRangePicker from "../../components/customDateRangePicker";
import { fetchCourtesies } from "../../apis/sessionsApi";
import useCourtesiesColumns from "./CommonColumns";

const PastCourtesies = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [pastCourtesies, setPastCourtesies] = useState([]);


  const fetchPastCourtesies = async (startDate, endDate) => {
    try{
        setIsLoading(true);
        setPastCourtesies([]);
        if(moment().isBefore(endDate)) {
            endDate = moment().format("YYYY-MM-DD");
        }
        const pastCourtesiesResponse = await fetchCourtesies(startDate, endDate); // TODO: sent only the date
        setPastCourtesies(pastCourtesiesResponse.data || []);
        setIsLoading(false);
    } catch (err) {
        message.error("Error loading data");
        setPastCourtesies([]);
        setIsLoading(false);
    }
  }

  const { columns, rowClassName } = useCourtesiesColumns();

  return (
    <>
      <h2 className="mt-5">Cortesías Pasadas</h2>
      <div className="text-center my-3">
        <CustomDateRangePicker months={2} maxDate={new Date()} onDateChange={fetchPastCourtesies} className="mb-5"/>
      </div>
      <Table
        className="table-responsive"
        rowClassName={rowClassName}
        dataSource={pastCourtesies}
        columns={columns}
        rowKey="user_id"
        pagination={true}
        scroll={{ x: true }}
        loading={isLoading}
      />
    </>
  );
};

export default PastCourtesies;